import React, { useState, createElement } from 'react';
import { SendIcon } from 'lucide-react';
const AccountabilityBuddySection = () => {
  // Get user name from localStorage for the message
  const getUserName = () => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const {
        profile
      } = JSON.parse(userData);
      return profile?.name || 'your friend';
    }
    return 'your friend';
  };
  const handleShareInvite = async () => {
    const messageText = `Hey, it's ${getUserName()}! I'm starting mentorship through PrideMentor and trying to stay consistent.
Would you be open to helping me stay on track?
If so, reply Y to this message and PrideMentor will send you occasional check-in nudges. 💜
To opt out, just reply N.`;
    try {
      if (navigator.share) {
        await navigator.share({
          text: messageText
        });
      } else {
        // Fallback for browsers without share API
        const textarea = document.createElement('textarea');
        textarea.value = messageText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        alert('Message copied to clipboard!');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };
  return <div className="max-w-2xl mx-auto" data-id="element-73">
      <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-74">
        <div className="text-center" data-id="element-75">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-76">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-77">
              <SendIcon size={24} className="text-purple-600" data-id="element-78" />
            </div>
            <h2 className="text-xl font-semibold" data-id="element-79">Add a support buddy</h2>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-80">
            Send a quick invite to a friend who can help keep you on track.
          </p>
          <button onClick={handleShareInvite} className="inline-flex items-center justify-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors" data-id="element-81">
            <SendIcon size={16} className="mr-2" data-id="element-82" />
            Share Invite
          </button>
        </div>
      </div>
    </div>;
};
export default AccountabilityBuddySection;